import { useContext } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableFooter, Typography
} from '@mui/material';
import { ticketsContext } from '../TicketsContext';
import { SimecUser, ClickableTableRow, DeleteIconButton } from 'components';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { applicationContext, appUserContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { localeContext } from 'helpers/Locale/LocaleManager';


let Results = () => {
    let { formatMessage } = useIntl();

    let history = useHistory();

    let { currentUser } = useContext(appUserContext);
    let { getCategoryById, getSubCategoryById } = useContext(applicationContext);
    let { currentLocale } = useContext(localeContext);

    let service = useContext(ticketsContext);

    return (
        <PerfectScrollbar>
            <div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Ticket</TableCell>
                            <TableCell>{formatMessage({ id: LocalizationIds.Priority })}</TableCell>
                            <TableCell>{formatMessage({ id: LocalizationIds.Status })}</TableCell>
                            <TableCell>{formatMessage({ id: LocalizationIds.Title })}</TableCell>
                            <TableCell>{formatMessage({ id: LocalizationIds.Orders })}</TableCell>
                            <TableCell>{formatMessage({ id: LocalizationIds.AssignedTo })}</TableCell>
                            <TableCell align="right" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.tickets.map((ticket, index) =>
                            <ClickableTableRow
                                hover
                                key={index}
                                onClick={(e) => {
                                    if (e.ctrlKey)
                                        window.open(`/ticket/edit/${ticket.number}`);
                                    else
                                        history.push(`/ticket/edit/${ticket.number}`)
                                }}
                            >
                                <TableCell><b>{ticket.number}</b></TableCell>
                                <TableCell>{ticket.ticketPriority}</TableCell>
                                <TableCell>
                                    {ticket.ticketStatus[currentLocale]}
                                    <div style={{ color: getCategoryById(ticket.categoryId)?.color ?? undefined }}>
                                        {`${getCategoryById(ticket.categoryId)?.name[currentLocale]} / ${getSubCategoryById(ticket.ticketSubCategoryId)?.names[currentLocale]}`}
                                    </div>
                                </TableCell>
                                <TableCell>{ticket.title}<br />{ticket.customerName}</TableCell>
                                <TableCell>
                                    {ticket.ordersCount > 0 &&
                                        <>
                                            {ticket.orders.map((x, index) =>
                                                <React.Fragment key={index}>
                                                    Ordine&nbsp;{x.orderType}{x.orderNumber}&nbsp;{x.orderTitle}{index < ticket.orders.length - 1 ? <br /> : ''}
                                                </React.Fragment>
                                            )}
                                            {ticket.ordersCount > 2 && ' ... +altri'}
                                        </>
                                    }
                                    {ticket.workOrdersCount > 0 &&
                                        <>
                                            {ticket.workOrders.map((x, index) =>
                                                <React.Fragment key={index}>
                                                    <b>{x.workOrderNumber}</b>&nbsp;{x.articleId}&nbsp;{x.articleModel}&nbsp;{x.articleVersion}&nbsp;{x.articleDescription}{index < ticket.workOrders.length - 1 ? <br /> : ''}
                                                </React.Fragment>
                                            )}
                                            {ticket.workOrdersCount > 2 && ` ... +${formatMessage({ id: LocalizationIds.Others }).toLowerCase()}`}
                                        </>
                                    }
                                </TableCell>
                                <TableCell>
                                    <SimecUser username={ticket.assigneeUserName} defaultValue={formatMessage({ id: LocalizationIds.NotAssigned })} />
                                </TableCell>
                                <TableCell align="right">
                                    {currentUser.simecClaims.canDeleteTicket &&
                                        <DeleteIconButton onClick={() => service.deleteTicket(ticket.ticketId)} stopPropagation />
                                    }
                                </TableCell>
                            </ClickableTableRow>
                        )}
                    </TableBody>
                    {service.tickets.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={7}>
                                    <Typography variant="subtitle2">{formatMessage({ id: LocalizationIds.NoDataFound })}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                    labelDisplayedRows={({ page, count }) =>
                        <>
                            {formatMessage({ id: LocalizationIds.TotalTickets })}:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            {formatMessage(
                                { id: LocalizationIds.PageOf },
                                { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                            )}
                        </>
                    }
                />
            </div>
        </PerfectScrollbar>

    );
}

export default Results;